import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import SubscriptionTiers from 'pobble-components/dist/subscriptions/tiers'
import { useHistory, useRouteMatch } from 'react-router-dom'

const styles = {
  container: {
    margin: '2em 0 3em',
    width: '100%'
  }
}

const Tiers = ({ classes, active }) => {
  const match = useRouteMatch()

  const activeTab =
    match.path === '/membership/moderation'
      ? 'moderation'
      : match.path === '/membership/parent'
        ? 'parent'
        : 'tl'

  const history = useHistory()

  const queryParams = useMemo(() => {
    return window.location.search
  }, [])

  return (
    <div className={classes.container}>
      <SubscriptionTiers
        activeTab={activeTab}
        setActiveTab={tab => {
          if (tab === 'tl') {
            history.push(`/membership${queryParams}`)
          }
          if (tab === 'moderation') {
            history.push(`/membership/moderation${queryParams}`)
          }
          if (tab === 'parent') {
            history.push(`/membership/parent${queryParams}`)
          }
        }}
        active={active}
        tabs
      />
    </div>
  )
}

export default injectSheet(styles)(Tiers)
